// extracted by mini-css-extract-plugin
module.exports = {"shadowBox":"ShadowBox_shadowBox__11jv8","clickable":"ShadowBox_clickable__5a9ga"};